import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TrackMode } from '@fitness-force/enum';

import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'track-mode',
  templateUrl: './track-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class TrackModeComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  getMode(value: any) {
    if (!value) return '-';
    else if (Object.keys(value).length === 0) {
      return '-';
    } else return TrackMode[value];
  }
}
